<template>
  <div class="tournament-info-wrapper col-12">
    <div class="d-flex justify-content-between">
      <Title
        class="mb-5"
        :text="$$t('Tournament Setup', 'tournament-setup-page-title')"
      />
    </div>

    <SectionGameAndPlatform />
    <SectionAppearance class="mt-6" />
    <SectionPaid v-if="isPaidTournamentAllowed" class="mt-6" />
    <SectionSchedule class="mt-6" />
    <SectionParticipants class="mt-6" />
    <SectionTournamentFormat class="mt-6" />
    <!-- <SectionTournamentMessage class="mt-6" /> -->

    <!-- <SectionAutomations class="mt-6" /> -->
    <SectionPrizes class="mt-6" />
    <SectionRegistrationForm class="mt-6" />
    <SectionRules class="mt-6" />
    <SectionLicense class="mt-6" />
    <SectionPromotion class="mt-6" />
    <SectionSharing class="mt-6" />
    <SectionAdmin class="mt-6" />
    <NotificationSetting class="mt-6" />
    <!-- <SectionAdditionalSettings class="my-6" /> -->
    <!-- <SectionEventOperations class="mt-6" /> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { translate } from '@/mixins/translate';
import SectionGameAndPlatform from '@/views/tournaments/management/singleTournament/components/SectionGameAndPlatform';
import SectionAppearance from '@/views/tournaments/management/singleTournament/components/SectionAppearance';
import SectionPromotion from '@/views/tournaments/management/singleTournament/components/SectionPromotion';
import SectionPaid from '@/views/tournaments/management/singleTournament/components/SectionPaid';
import SectionAdmin from './components/SectionAdmin.vue';
import SectionLicense from './components/SectionLicense.vue';
import SectionSchedule from '@/views/tournaments/management/singleTournament/components/SectionSchedule';
import SectionTournamentFormat from '@/views/tournaments/management/singleTournament/components/SectionTournamentFormat';
// import SectionTournamentMessage from '@/views/tournaments/management/singleTournament/components/SectionTournamentMessage';
// import SectionAutomations from '@/views/tournaments/management/singleTournament/components/SectionAutomation';
import SectionParticipants from '@/views/tournaments/management/singleTournament/components/SectionParticipantSettings';
// import SectionAdditionalSettings from '@/views/tournaments/management/singleTournament/components/SectionAdditionalSettings';
import SectionRegistrationForm from '@/views/tournaments/management/singleTournament/components/SectionRegistrationForm';
import SectionPrizes from '@/views/tournaments/management/singleTournament/components/SectionPrizes';
import SectionRules from '@/views/tournaments/management/singleTournament/components/SectionRules';
import SectionSharing from '@/views/tournaments/management/singleTournament/components/SharingSection';
import NotificationSetting from '@/views/tournaments/management/singleTournament/components/SettingsNotifications';
import Title from '@/components/atoms/Title';

export default {
  name: 'TournamentInfo',
  inject: ['$validator'],
  components: {
    Title,
    SectionRules,
    SectionPrizes,
    SectionLicense,
    SectionRegistrationForm,
    SectionTournamentFormat,
    SectionGameAndPlatform,
    SectionAppearance,
    SectionPromotion,
    SectionSchedule,
    SectionParticipants,
    SectionSharing,
    SectionPaid,
    NotificationSetting,
    SectionAdmin,
    // SectionTournamentMessage,
    // SectionAutomations,
  },
  mixins: [translate('_web_tournament_settings')],
  props: {
    titleTranslationKey: {
      type: String,
      default: '_web_tournament_game_default-title',
    },
  },

  data() {
    return {
      isPaidTournamentAllowed: false,
    };
  },
  computed: {
    ...mapState('my', ['account']),
    ...mapGetters(['currentTournament']),
  },

  created() {
    //init default values
    if (!this.$route.params.tournamentID) {
      let event_organizer = {
        isAvailable: true,
        name: this.account._name,
        logo: null,
      };
      this.premmisionCheck();
      this.updateCurrentTournament([
        {
          event_organizer,
          component: 'info',
        },
        {
          auto_activation_mode: true,
          component: 'schedule',
        },
        {
          qualification_type: 'first_registered',
          squads: 32,
          full_teams: false,
          component: 'players_config',
        },
        {
          required: false,
          currency: '',
          cost: 0,
          component: 'entry_fee',
        },
        {
          country: this.account.country,
          country_id: this.account.countryId,
          component: 'info',
        },
      ]);
    }
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    premmisionCheck() {
      const accessTokenString = localStorage.getItem('accessToken');

      if (accessTokenString) {
        try {
          const accessTokenObject = JSON.parse(accessTokenString);

          const token = accessTokenObject.token;
          const payload = token.split('.')[1];
          const decodedPayload = atob(payload);
          const permissions = JSON.parse(decodedPayload).permissions;
          const arrayOfTournamentRoot = permissions.filter(
            item => item.Root === 'tournament'
          );
          if (arrayOfTournamentRoot) {
            const arrayOfPaidTournament = arrayOfTournamentRoot.filter(
              item => item.Action === 'paid_tournament'
            );
            return (this.isPaidTournamentAllowed =
              arrayOfPaidTournament.length > 0 ? true : false);
          }
        } catch (error) {
          console.error('Error decoding Base64:', error);
        }
      } else {
        console.error('Access token not found in local storage.');
      }
    },
  },
};
</script>
